import React, { memo } from 'react';
import { useDispatch } from 'react-redux';
import Image from "../../../common/Image/ImageLazyWrapper";
import { toggleInventoryBatch } from '../../../actions/productInventory';
import styles from './styles/product-listing.scss';
import Button from 'jd-library/Button';
import { getInventoryImagePath } from '../productrinventory.common.utils';
import { useHistory } from 'react-router-dom';
import { checkLoggedIn } from '../../../utills';

function getProductIndication(productStatus) {
  switch (true) {

    case productStatus === 'LOWINVENTORY':
      return (<div className={`${styles['pending-text']}`}>
        <div><span className={`icon-alertNew icon-pending-alert`}></span></div>
        <div className={styles['pending-status']}>Low Inventory</div>
      </div>)

    case productStatus === 'OUTOFSTOCK':
      return (<div className={`${styles['pending-text']} ${styles['delete']}`}>
        <div><span className={`icon-alertNew icon-pending-alert`}></span></div>
        <div className={styles['pending-status']}>Out of Stock</div>
      </div>)

    default:
      return null;
  }
}

const NoImageForTemplate = (props) => {
  const imageProps = {
    style: {
      borderRadius: '10px'
    },
    imgClass: styles['no-img-image'],
    finalImageSrc: "https://image1.jdomni.in/jdomni_email/NOIMAGE_2002211157.png",
    retainRandomColor: true,
  }
  return (
    <div className="no-img template-product" onClick={() => {
      props.onClick && props.onClick()
    }}>
      <Image {...imageProps} />
    </div>
  );
};

function getHighlightedtext(value, search) {
  const regex = new RegExp(`(${search})`, 'gi');
  const text = value.split(regex);
  return text.map((part) => regex.test(part) ? (
    <strong>{part}</strong>
  ) : (
    <span>{part}</span>
  ))
}

function ProductList(props) {
  const { item: {
    productName, SalesForLast30Days,
    quantity, EstimatedDaysOfCover, imageUrl, productStatus,isTemplate
  },
    searchText } = props;
  const dispatch = useDispatch();
  let history = useHistory();

  const handleViewInventory = () => {
    if (!props.loggedIn) {
      checkLoggedIn({ history, inventory: true });
      return;
    }
    dispatch(toggleInventoryBatch(props.item));
    localStorage.setItem('inventorydata', JSON.stringify(props.item));
    localStorage.setItem('isinventorydiag', true);
  }

  const handleImageError = (e) => {
    e.target.src = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
  }

  const formatImageUrl = getInventoryImagePath(imageUrl.split(',')[0],isTemplate);

  return (
    <div className={styles['inventory-product-block']}>
      <div>
        {formatImageUrl.includes('http') ?
          <div className='img-holder'>
            <div className='img-rounded'>
              <img src={formatImageUrl} alt="" onError={handleImageError} />

            </div>
          </div>
          : <div className='img-holder'><div className='no-img'><NoImageForTemplate /></div></div>}
      </div>
      <div className='inventory-desc'>
        <div className='inventory-prod-title'>{searchText ? getHighlightedtext(productName, searchText) : productName}</div>
        {getProductIndication(productStatus)}
        <div className='inventory-details-text'>
          Sale for the last 30 days: <span className="count-text">{SalesForLast30Days || 'NA'}</span>
        </div>
        <div className='inventory-details-text'>
          In Stock Qty:  <span className={`${styles['count-text']} ${productStatus === 'OUTOFSTOCK' || quantity === 0 ? 'red' : ''}`}>{quantity}</span>
        </div>
        <div className='inventory-details-text'>
          Estimated days of Cover: <span className={`${styles['count-text']}  ${(productStatus === 'LOWINVENTORY' || EstimatedDaysOfCover < 15) && SalesForLast30Days ? 'red' : ''}`}>{SalesForLast30Days ? (EstimatedDaysOfCover + ' Days') : 'NA'}</span>
        </div>
        <div className={styles['suggest-button-holder']}>
          <Button
            className={styles['suggest-btn']}
            variant={'default'}
            block
            clickHandler={handleViewInventory}
          >
            <i className={'icon-addInventory'} />
            <div className={'btn-txt'}>{'Edit Inventory'}</div>
          </Button>
        </div>
      </div>
      <div className={styles['fake-border']}></div>
    </div>
  )
}

export default memo(ProductList)